// custom-reviews.js
console.log('[Custom Reviews] Script initialized. Starting polling for modal...');

// Capture URL, checking sessionStorage in case a rapid redirect (e.g. Age Verification or Language app) just happened
const savedReviewUrl = sessionStorage.getItem('savedReviewUrl');
const rawUrl = savedReviewUrl || window.customReviewInitialUrl || window.location.href;
const rawHash = savedReviewUrl || window.customReviewInitialHash || window.location.hash;

if (savedReviewUrl) {
  console.log('[Custom Reviews] Recovered URL from sessionStorage after rapid redirect:', savedReviewUrl);
  sessionStorage.removeItem('savedReviewUrl'); // Clean up
}

const initialUrl = rawUrl.toLowerCase();
const initialHash = rawHash.toLowerCase();

console.log('[Custom Reviews] Analyzed URL:', initialUrl);

// Broadened check to catch any variation in URL OR Hash
const hasWriteReview = initialUrl.includes('write_review') || initialUrl.includes('review=true') || initialHash.includes('write_review');
console.log('[Custom Reviews] hasWriteReview evaluated to:', hasWriteReview);

let customerEmail = null;
const emailMatch = rawUrl.match(/[?&]email=([^&]+)/i) || rawHash.match(/[#&]email=([^&]+)/i);
if (emailMatch && emailMatch[1]) {
  try {
    // Probeer de Base64 string te decoden
    customerEmail = atob(decodeURIComponent(emailMatch[1]));
  } catch (e) {
    // Fallback: Als het geen geldige Base64 is, gebruik de originele tekstwaarde
    customerEmail = decodeURIComponent(emailMatch[1]);
  }
}

// Global debug function to manually trigger it from the console
window.debugOpenReviewModal = () => {
  console.log('[Custom Reviews] Forcing modal open via debug function...');
  const modal = document.getElementById('customReviewModal') || document.querySelector('.custom-review-modal');
  if (modal) {
    if (typeof modal.showModal === 'function') modal.showModal();
    else modal.setAttribute('open', '');
  } else {
    console.error('Modal not found in DOM!');
  }
};

const checkInterval = setInterval(() => {
  const modal = document.getElementById('customReviewModal') || document.querySelector('.custom-review-modal');
  const writeReviewBtn = document.getElementById('writeReviewBtn');
  const closeBtn = document.getElementById('closeReviewModal') || document.querySelector('.close-btn');
  const form = document.getElementById('customReviewForm');
  const ratingStars = document.querySelectorAll('.star-rating');
  const ratingValue = document.getElementById('ratingValue');
  const feedbackEl = document.getElementById('reviewFeedback');
  const emailInput = document.getElementById('reviewEmail');

  if (modal) {
    clearInterval(checkInterval);
    console.log('[Custom Reviews] Target found! Modal exists in DOM.');
    
    // Initialization: Pre-fill stars to 5 by default
    if (ratingStars.length > 0) {
      updateStars(5);
    }

    if (hasWriteReview) {
      console.log('[Custom Reviews] Opening modal from URL trigger.');
      console.log('[Custom Reviews] Email found in URL:', customerEmail);

      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
      
      if (customerEmail && emailInput) {
        emailInput.value = customerEmail;
        emailInput.setAttribute('readonly', 'true');
        emailInput.style.backgroundColor = '#f5f5f5';
      }
    }

    if (writeReviewBtn) {
      writeReviewBtn.addEventListener('click', () => {
        if (typeof modal.showModal === 'function') {
          modal.showModal();
        } else {
          modal.setAttribute('open', '');
        }
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        if (typeof modal.close === 'function') {
          modal.close();
        } else {
          modal.removeAttribute('open');
        }
      });
    }

    // Close modal when clicking outside
    modal.addEventListener('click', (e) => {
      const dialogDimensions = modal.getBoundingClientRect();
      if (
        e.clientX < dialogDimensions.left ||
        e.clientX > dialogDimensions.right ||
        e.clientY < dialogDimensions.top ||
        e.clientY > dialogDimensions.bottom
      ) {
        if (typeof modal.close === 'function') {
          modal.close();
        } else {
          modal.removeAttribute('open');
        }
      }
    });

    // Star Rating Interactivity
    ratingStars.forEach(star => {
      star.addEventListener('click', (e) => {
        const val = parseInt(e.currentTarget.getAttribute('data-value'));
        if(ratingValue) ratingValue.value = val;
        updateStars(val);
      });
      
      star.addEventListener('mouseenter', (e) => {
        const val = parseInt(e.currentTarget.getAttribute('data-value'));
        updateStars(val, true);
      });
      
      star.addEventListener('mouseleave', () => {
        if(ratingValue) {
          updateStars(parseInt(ratingValue.value));
        }
      });
    });

    function updateStars(val, isHover = false) {
      ratingStars.forEach(star => {
        const starVal = parseInt(star.getAttribute('data-value'));
        if (starVal <= val) {
          star.classList.add('active');
          star.style.fill = '#FFD700';
          star.style.stroke = '#FFD700';
        } else {
          star.classList.remove('active');
          star.style.fill = 'none';
          star.style.stroke = '#E0E0E0';
        }
      });
    }

    // Form Submission (Hook into Judge.me API)
    if (form) {
      const textSubmit = form.getAttribute('data-text-submit') || 'Submit Review';
      const textSubmitting = form.getAttribute('data-text-submitting') || 'Submitting...';
      const textSuccess = form.getAttribute('data-text-success') || 'Thank you! Your review has been submitted.';
      const textError = form.getAttribute('data-text-error') || 'Failed to submit review. Please try again.';

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        
        const submitBtn = document.getElementById('submitReviewBtn');
        if(submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = textSubmitting;
        }
        if(feedbackEl) feedbackEl.style.display = 'none';

        const formData = new FormData(form);
        const shopDomain = 'perfecte-wijn.myshopify.com';
        const apiToken = 'Wk0HSjNbTRgMAQIKvlDX0UAEUb4';
        
        formData.append('shop_domain', shopDomain);
        formData.append('platform', 'shopify');

        try {
          // Send request with mode: 'no-cors' to bypass browser CORS block.
          // The request is sent as multipart/form-data, avoiding OPTIONS preflight.
          // The response will be opaque, meaning we can't read JSON or status codes,
          // so we assume success if no network crash occurs.
          await fetch(`https://judge.me/api/v1/reviews?api_token=${apiToken}`, {
            method: 'POST',
            mode: 'no-cors',
            body: formData
          });

          // Assume success since no-cors gives opaque response
          
          // --- Custom Klaviyo Event: Submitted Wine Review ---
          try {
            const klaviyoEventName = "Submitted Wine Review";
            const customerEmailForEvent = customerEmail || (emailInput ? emailInput.value : '');
            const productName = form.getAttribute('data-product-name') || '';
            const productVintage = form.getAttribute('data-product-vintage') || '';
            const ratingForEvent = document.getElementById('ratingValue') ? document.getElementById('ratingValue').value : 5;
            
            if (typeof _learnq !== 'undefined' && customerEmailForEvent) {
              _learnq.push(['identify', { '$email': customerEmailForEvent }]);
              _learnq.push(['track', klaviyoEventName, {
                'Product Name': productName,
                'Rating': parseInt(ratingForEvent, 10),
                'Vintage': productVintage
              }]);
              console.log('[Custom Reviews] Fired Klaviyo Event:', klaviyoEventName);
            }
          } catch(e) {
            console.error('[Custom Reviews] Failed to push Klaviyo event:', e);
          }
          // ---------------------------------------------------

          form.reset();
          updateStars(5);
          if(feedbackEl) {
            feedbackEl.textContent = textSuccess;
            feedbackEl.style.color = '#2e7d32';
            feedbackEl.style.display = 'block';
          }
          
          setTimeout(() => {
            if (typeof modal.close === 'function') {
              modal.close();
            } else {
              modal.removeAttribute('open');
            }
            if(feedbackEl) feedbackEl.style.display = 'none';
            if(submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = textSubmit;
            }
          }, 3000);
        } catch (error) {
          console.error('[Custom Reviews] Full Exception:', error);
          if(feedbackEl) {
            feedbackEl.textContent = textError;
            feedbackEl.style.color = '#d32f2f';
            feedbackEl.style.display = 'block';
          }
          if(submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = textSubmit;
          }
        }
      });
    }
  }
}, 200);

// Stop sowieso na 10 seconden om oneindige loops te voorkomen
setTimeout(() => clearInterval(checkInterval), 10000);
